/* global Browser */
import {getClosestByClass} from '../lib/helper';
import {register} from '../lib/component';
//import Browser from '../lib/browser';
import Swiper from '../custom/swiper';
import LazyLoadingImage from './LazyLoadingImage';
import Header from './Header';
import Sticky from './Sticky';
import Selector from './Selector';
import styleSelect from './styleSelect';
import SplitDropdown from './SplitDropdown';
import AddTo from './AddTo';
/* import slider.stage from './slider.stage'; */
import Overlay from './Overlay';
import LightBox from './LightBox';
import Tabs from './Tabs';
import Accordion from './Accordion';
import Faccordion from './Faccordion';
import TabSelector from './TabSelector';
import SpecialSelector from './SpecialSelector';
import SortingDisplay from './SortingDisplay';
import OverflowingSwiper from './OverflowingSwiper';
import ParallaxCover from './ParallaxCover';
import ReviewForm from './ReviewForm';
import AjaxForm from './AjaxForm';
import DownloadForm from './DownloadForm';
import Autocomplete from './Autocomplete';
import MultiSelector from './MultiSelector';
import Dropdown from './Dropdown';
import FormSubfields from './FormSubfields';
import FilterSubmit from './FilterSubmit';
import RangSlider from './RangSlider';
import Validator from './Validator';
import Form from './Form';
import StepHandlerMobile from './StepHandlerMobile';
import AccordionRadioBtn from './AccordionRadioBtn';
import EditAccountData from './EditAccountData';
import BackToTop from './BackToTop';
/* import Coupon from './Coupon'; */
import Switch from './Switch';
import CartHint from './CartHint';
import Reminder from './Reminder';
import AppNotification from './AppNotification';
import Quickview from './Quickview';
import Tooltip from './Tooltip';
import Dismissable from './Dismissable';
import ContentLoader from './ContentLoader';
import BulkContentLoader from './BulkContentLoader';

const slideToOffset = 50;

/**
 *
 * @type {Class}
 */
export default class TabsSwipeable extends Tabs {

  constructor(el) {

    super(el);

    this.el = el;
    this.header = this.el.querySelector('.tc-tabs-swipeable-header');
    this.headerSwiperContainer = this.header.querySelector('.swiper-container');
    this.headerSwiperWrapper = this.header.querySelector('.swiper-wrapper');
    this.headerSwiperPrevTrigger = this.header.querySelector('.tab-button-prev');
    this.headerSwiperNextTrigger = this.header.querySelector('.tab-button-next');
    this.subModuleName = 'OverflowingSwiper';
    this.subModuleSelector = '.tc-overflowing-slider';
    this.headerSwiperOptions = {
      loop: false,
      spaceBetween: 20,
      centeredSlides: false,
      paginationClickable: false,
      grabCursor: false,
      threshold: 20,
      simulateTouch: !(Browser.browser.major === '9' && Browser.isIE),
      slidesPerView: 'auto',
      effect: 'slide'
    };

    this.recalcIEWrapperWidth = () => {

      this.headerSwiperWrapper.style.width = parseInt(this.headerSwiperWrapper.style.width.replace('px', ''), 10) + 30 + 'px';
    };

    if (this.el.querySelector(this.subModuleSelector)) {

      this.subModuleFullSelector = `.${this.activeTabContent.className.replace(' ', '.')} ${this.subModuleSelector}`;
      switch (true) {
      case this.subModuleName.indexOf('LazyLoadingImage') > -1:
        this.subModule = LazyLoadingImage;
        break;

      case this.subModuleName.indexOf('Header') > -1:
        this.subModule = Header;
        break;

      case this.subModuleName.indexOf('Sticky') > -1:
        this.subModule = Sticky;
        break;

      case this.subModuleName.indexOf('Selector') > -1:
        this.subModule = Selector;
        break;

      case this.subModuleName.indexOf('styleSelect') > -1:
        this.subModule = styleSelect;
        break;

      case this.subModuleName.indexOf('SplitDropdown') > -1:
        this.subModule = SplitDropdown;
        break;

      case this.subModuleName.indexOf('AddTo') > -1:
        this.subModule = AddTo;
        break;

        /* case this.subModuleName.indexOf('slider.stage') > -1:
          this.subModule = slider.stage;
          break;
       */
      case this.subModuleName.indexOf('Overlay') > -1:
        this.subModule = Overlay;
        break;

      case this.subModuleName.indexOf('LightBox') > -1:
        this.subModule = LightBox;
        break;

      case this.subModuleName.indexOf('Tabs') > -1:
        this.subModule = Tabs;
        break;

      case this.subModuleName.indexOf('TabsSwipeable') > -1:
        this.subModule = TabsSwipeable;
        break;

      case this.subModuleName.indexOf('Accordion') > -1:
        this.subModule = Accordion;
        break;

      case this.subModuleName.indexOf('Faccordion') > -1:
        this.subModule = Faccordion;
        break;

      case this.subModuleName.indexOf('TabSelector') > -1:
        this.subModule = TabSelector;
        break;

      case this.subModuleName.indexOf('SpecialSelector') > -1:
        this.subModule = SpecialSelector;
        break;

      case this.subModuleName.indexOf('SortingDisplay') > -1:
        this.subModule = SortingDisplay;
        break;

      case this.subModuleName.indexOf('OverflowingSwiper') > -1:
        this.subModule = OverflowingSwiper;
        break;

      case this.subModuleName.indexOf('ParallaxCover') > -1:
        this.subModule = ParallaxCover;
        break;

      case this.subModuleName.indexOf('ReviewForm') > -1:
        this.subModule = ReviewForm;
        break;

      case this.subModuleName.indexOf('AjaxForm') > -1:
        this.subModule = AjaxForm;
        break;

      case this.subModuleName.indexOf('DownloadForm') > -1:
        this.subModule = DownloadForm;
        break;

      case this.subModuleName.indexOf('Autocomplete') > -1:
        this.subModule = Autocomplete;
        break;

      case this.subModuleName.indexOf('MultiSelector') > -1:
        this.subModule = MultiSelector;
        break;

      case this.subModuleName.indexOf('Dropdown') > -1:
        this.subModule = Dropdown;
        break;

      case this.subModuleName.indexOf('FormSubfields') > -1:
        this.subModule = FormSubfields;
        break;

      case this.subModuleName.indexOf('FilterSubmit') > -1:
        this.subModule = FilterSubmit;
        break;

      case this.subModuleName.indexOf('RangSlider') > -1:
        this.subModule = RangSlider;
        break;

      case this.subModuleName.indexOf('Validator') > -1:
        this.subModule = Validator;
        break;

      case this.subModuleName.indexOf('Form') > -1:
        this.subModule = Form;
        break;

      case this.subModuleName.indexOf('StepHandlerMobile') > -1:
        this.subModule = StepHandlerMobile;
        break;

      case this.subModuleName.indexOf('AccordionRadioBtn') > -1:
        this.subModule = AccordionRadioBtn;
        break;

      case this.subModuleName.indexOf('EditAccountData') > -1:
        this.subModule = EditAccountData;
        break;

      case this.subModuleName.indexOf('BackToTop') > -1:
        this.subModule = BackToTop;
        break;

      case this.subModuleName.indexOf('Switch') > -1:
        this.subModule = Switch;
        break;

      case this.subModuleName.indexOf('CartHint') > -1:
        this.subModule = CartHint;
        break;

      case this.subModuleName.indexOf('Reminder') > -1:
        this.subModule = Reminder;
        break;

      case this.subModuleName.indexOf('AppNotification') > -1:
        this.subModule = AppNotification;
        break;

      case this.subModuleName.indexOf('Quickview') > -1:
        this.subModule = Quickview;
        break;

      case this.subModuleName.indexOf('Tooltip') > -1:
        this.subModule = Tooltip;
        break;

      case this.subModuleName.indexOf('Dismissable') > -1:
        this.subModule = Dismissable;
        break;

      case this.subModuleName.indexOf('ContentLoader') > -1:
        this.subModule = ContentLoader;
        break;

      case this.subModuleName.indexOf('BulkContentLoader') > -1:
        this.subModule = BulkContentLoader;
        break;
      }
      this.initSubModule();
    }

    // WHAAAT: #15528

    window.setTimeout(() => {

      this.el.style.minHeight = this.el.offsetHeight + 'px';
    }, 300);

    this.initHeaderSwiper();
    this.checkGradient();
    this.registerTabSwipableEvents();
  }

  registerTabSwipableEvents() {

    this.headerSwiperPrevTrigger.addEventListener('click', this.onClickPrev.bind(this), false);
    this.headerSwiperNextTrigger.addEventListener('click', this.onClickNext.bind(this), false);

    if (this.subModule) {

      this.el.addEventListener('tabChange', this.onTabChangeSwipableTabs.bind(this), false);
    }

    window.addEventListener('resize', this.checkGradient.bind(this), false);
  }

  onTabChangeSwipableTabs(e) {

    this.checkGradient(e);
    this.handleInViewCheck(e);
    this.initSubModule();
  }

  initHeaderSwiper() {

    if (Browser.browser.major === '9' && Browser.isIE) {

      this.headerSwiperOptions.onInit = this.recalcIEWrapperWidth;
    }

    this.headerSwiper = new Swiper(this.headerSwiperContainer, this.headerSwiperOptions);

    this.triggers.map(trigger => {

      trigger.slideEl = getClosestByClass(trigger, 'swiper-slide');

      return trigger;
    });
  }

  initSubModule() {

    if (!this.activeTabContent.subModule) {

      register(this.subModule, this.subModuleSelector, this.activeTabContent);
      this.activeTabContent.subModule = this.activeTabContent.querySelectorAll(this.subModuleSelector);
    }
  }

  checkGradient(e, modifier = 0) {

    if (Browser.browser.major === '9' && Browser.isIE) {

      this.recalcIEWrapperWidth();
    }

    const activeIndex = this.getActiveIndex();

    if (activeIndex === 0 && modifier <= 0 || activeIndex === 1 && modifier < 0) {

      // remove gradient
      this.el.classList.remove('is-first-step');
    } else {

      this.el.classList.add('is-first-step');
    }

    if (activeIndex === this.triggers.length - 1 && modifier >= 0 || activeIndex === this.triggers.length - 2 && modifier > 0) {

      // remove gradient
      this.el.classList.remove('is-last-step');
    } else {

      this.el.classList.add('is-last-step');
    }

    if (this.headerSwiper.isEnd && this.headerSwiper.isStart) {

      this.el.classList.remove('is-first-step');
      this.el.classList.remove('is-last-step');
    }

    if (e && e.type === 'resize') {

      if (this.headerSwiper.slides[activeIndex - 2]) {

        this.headerSwiper.slideTo(activeIndex - 2);
      } else {

        this.headerSwiper.slideTo(activeIndex - 1);
      }
    }
  }

  handleInViewCheck(e, modifier = 0) {

    const activeIndex = this.getActiveIndex();

    if (this.slideInView(this.triggers[activeIndex + modifier], this.headerSwiperContainer)) {

      // try to get a slide between new active and wrapper for the gradient
      if (this.headerSwiper.slides[activeIndex - 1 + modifier]) {

        this.headerSwiper.slideTo(activeIndex - 1 + modifier);
      } else {

        this.headerSwiper.slideTo(activeIndex + modifier);
      }
    }
  }

  getActiveIndex() {

    return this.triggers.indexOf(this.activeTrigger);
  }

  onClickPrev(e) {

    const activeIndex = this.getActiveIndex();

    // start reached
    if (activeIndex === 0) {

      return;
    }

    this.checkGradient(false, -1);
    this.handleInViewCheck(false, -1);

    this.onClick(this.triggers[activeIndex - 1]);
  }

  onClickNext(e) {

    const activeIndex = this.getActiveIndex();

    // end reached
    if (activeIndex === this.triggers.length - 1) {

      return;
    }

    this.checkGradient(false, 1);
    this.handleInViewCheck(false, 1);

    this.onClick(this.triggers[activeIndex + 1]);
  }

  slideInView(slide, container) {

    const slideBound = slide.getBoundingClientRect();
    const containerBound = container.getBoundingClientRect();

    if ((slideBound.right + slideToOffset) > containerBound.right || (slideBound.left - slideToOffset) < containerBound.left) {

      return true;
    }

    return false;
  }
};
